module.exports = __webpack_public_path__ + "img/speed.4cfaa1f5.png";